import React from "react";
import { textCase } from "../ui/UI";
import AppTranslation from "../app_translation/AppTranslation";

const UtilityHelper = new (class UtilityHelper {
  timeFormatStr: string = "hh:mm A";
  dateFormatStr: string = "DD/MM/YY"; //'DD MMM YY' //'DD/MM/YY'
  defaultWidthMin: number = Number(
    process.env.REACT_APP_chat_screen_min_width ?? "0"
  );
  defaultAudioMaxSeconds: number = Number(
    process.env.REACT_APP_chat_audio_seconds_max ?? "0"
  );

  isEmpty = (s: string): boolean => {
    return typeof s === "undefined" || s === null || s.trim().length === 0;
  };

  isNotEmpty = (s: string): boolean => {
    return !(typeof s === "undefined" || s === null || s.trim().length === 0);
  };

  isDigit = (c: string): boolean => {
    return c >= "0" && c <= "9";
  };

  isEmail = (email: string): boolean => {
    /* var re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; */
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  isNumber = (value: string): boolean => !isNaN(Number(value));

  checkSpecialChar = (string: string): boolean => {
    //var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

    //var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]+/;
    var format = /[[\] `!@#$%^&*()_+=\-{};':"\\|,<>/?]+/;

    return format.test(string) ? true : false;
  };

  checkSocialSpecialChar = (string: string): boolean => {
    //var format = /[ `!@#$%^&*()_+\=\[\]{};':"\\|,<>\/?]+/;
    var format = /[[\] `!@#$%^&*()_+= {}';:"\\|,<>/?]+/;
    return format.test(string) ? true : false;
  };

  removeSpecialChar = (text: string): string => {
    //const  regExpr = /[^a-zA-Z0-9-. ]/g; // excluded space and .
    const regExpr = /[^a-zA-Z0-9-]/g;
    return text.replace(regExpr, "");
  };

  isValidURL = (str: string): boolean => {
    /*  var regex =
      /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/; */
    var regex =
      /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!/-]))?/;
    if (!regex.test(str)) {
      return false;
    } else {
      return true;
    }
  };

  arraySum = (arrayProvided = []): number => {
    return arrayProvided.reduce((a, b) => a + b, 0);
  };

  naviagteGoogleMap = (latitude: string, longitude: string) => {
    if (this.isNotEmpty(latitude) && this.isNotEmpty(longitude)) {
      this.navigateTab(`https://maps.google.com/?q=${latitude},${longitude}`);
    }
  };

  redirectToSite = () => {
    const siteUrl = process.env.REACT_APP_site_url ?? "https://communicatr.co";
    this.navigateTab(siteUrl, "_self");
  };

  navigateTab = (url: string, target: "_self" | "_blank" = "_blank") => {
    if (this.isNotEmpty(url)) {
      const urlArr: Array<string> = url.split("://");
      if (urlArr.length === 1) {
        url = `http://${url}`;
      }
      window.open(url, target);
    }
  };

  areArraysEqualUnordered = (a: string[], b: string[]): boolean => {
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((val, index) => val === sortedB[index]);
  };

  countWords = (str: string): number => {
    // Remove extra spaces and split by whitespace
    const words = str.trim().split(/\s+/);
    return str.trim() === "" ? 0 : words.length;
  };

  wrapKeyword = (text: string, searchValue: string): string => {
    let htmlContent = textCase(text);
    const searchVal = searchValue.toLowerCase();
    if (this.isNotEmpty(text) && this.isNotEmpty(searchValue)) {
      text = text.toLowerCase();
      htmlContent = text.replaceAll(
        searchVal,
        `<span class="keyword-string color-theme-sublabel">${searchVal}</span>`
      );

      return textCase(htmlContent);
    }
    return htmlContent;
  };

  maskName = (name: string): string => {
    return name[0] + "*".repeat(name.length - 1);
  };

  maskPhoneNumber = (input: string, hideLenght: number = 6): string => {
    if (input.length <= 6) {
      return "*".repeat(input.length);
    }

    const visiblePart = input.substring(0, input.length - hideLenght);
    return visiblePart + "*".repeat(hideLenght);
  };

  phoneNumberValid = (s: string): boolean => {
    return s.length <= 9 && s.length >= 4;
  };

  getBrowerAgent = (showVersion = false): string => {
    /* type BrowserType =
      | "Chrome"
      | "Firefox"
      | "Safari"
      | "Edge"
      | "Opera"
      | "Brave"
      | "Unknown"; */

    const userAgent = navigator.userAgent;
    let browserName = "";

    if (userAgent.includes("Brave")) browserName = "Brave";
    else if (userAgent.includes("Edg")) browserName = "Edge";
    else if (userAgent.includes("OPR") || userAgent.includes("Opera"))
      browserName = "Opera";
    else if (userAgent.includes("Chrome")) browserName = "Chrome";
    else if (userAgent.includes("Safari")) browserName = "Safari";
    else if (userAgent.includes("Firefox")) browserName = "Firefox";
    else browserName = "Unknown";

    return browserName.toLowerCase(); // outputs: `Chrome 92`
  };

  getUrlCompanyCode = (): string => {
    const segments = window.location.pathname.split("/").filter(Boolean);
    const code: string = segments[0];
    return code;
  };

  getLastArrayStringValue = (str: string): string => {
    const arr: Array<string> = str.split("/");
    return arr[arr.length - 1];
  };

  delay = (ms: number = 350) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  stopAllAudio = () => {
    console.log(`stopAllAudio`);
    const audios = document.querySelectorAll("audio");
    audios.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0; // reset to start
    });
  };

  isStringMap = (value: any): value is { [key: string]: string } => {
    if (value === null || typeof value !== "object" || Array.isArray(value)) {
      return false;
    }

    // Check all values are strings
    return Object.values(value).every((v) => typeof v === "string");
  };

  base64ToFile = (base64: string, filename: string): File => {
    const arr = base64.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) throw new Error("Invalid base64 string");

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        if (reader.result) {
          resolve(reader.result as string); // Resolve with Base64 string
        } else {
          reject(new Error("Failed to convert video Blob to Base64"));
        }
      };

      reader.onerror = (error) => {
        reject(error);
      };

      // Read the Blob as Data URL (Base64)
      reader.readAsDataURL(blob);
    });
  };

  isNodeEmpty = (node: React.ReactNode): boolean => {
    if (
      node === null ||
      node === undefined ||
      node === false ||
      node === true ||
      node === ""
    ) {
      return true;
    }

    // Count children (handles arrays, JSX)
    return React.Children.count(node) === 0;
  };

  ARFLabel = (formType: string): string => {
    let title = "";
    if (formType === "1") {
      title = AppTranslation.text("feedback");
    } else if (formType === "2") {
      title = AppTranslation.text("appointment");
    } else if (formType === "3") {
      title = AppTranslation.text("reservation");
    }

    return title;
  };

  isValidDate = (value: any): boolean => {
    const d = new Date(value);
    return d instanceof Date && !isNaN(d.getTime());
  };

  hexToRgb = (hex: string) => {
    hex = hex.replace(/^#/, "");
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((x) => x + x)
        .join("");
    }
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    return { r, g, b };
  };

  hexToFilter(hex: string): string {
    const { r, g, b } = this.hexToRgb(hex);

    // normalize RGB to 0-1
    const rn = r / 255;
    const gn = g / 255;
    const bn = b / 255;

    // crude approximation
    const invert = 1 - Math.max(rn, gn, bn);
    const sepia = (rn + gn + bn) / 3;
    const saturate = 100; // can adjust
    const hueRotate = 0; // can adjust
    const brightness = 1;
    const contrast = 1;

    return `invert(${invert}) sepia(${sepia}) saturate(${saturate}%) hue-rotate(${hueRotate}deg) brightness(${brightness}) contrast(${contrast})`;
  }

  hexToRgba(hex: string, alpha: number): string {
    // Remove "#" if present
    hex = hex.replace(/^#/, "");

    // Handle short hex (#abc)
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  formatDate = (date: Date): string => {
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  // Helper to format seconds as MM:SS
  formatTimer = (sec: number): string => {
    const minutes = Math.floor(sec / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (sec % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  checkStandAlone = (): boolean => {
    const isStandaloneAndroid = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    const isIOSStandaloneIOS = (window.navigator as any).standalone === true;

    return [isStandaloneAndroid, isIOSStandaloneIOS].includes(true);
  };

  getUrlLastPathName = (): string => {
    const pathArr: Array<string> = window.location.pathname.split("/");
    const pathName: string = pathArr[pathArr.length - 1];

    return pathName.toLowerCase();
  };

  getFullPathName = () => {
    const code: string = this.getUrlCompanyCode();
    let pullPath: string = window.location.pathname;
    pullPath = pullPath.replaceAll(`/${code}`, "");
    return pullPath;
  };

  fixEmoji(text: string): string {
    try {
      return decodeURIComponent(escape(text));
    } catch (e) {
      //console.error("URI malformed:", e);
      return text; // or you can return a default value
    }
  }

  linkifyText = (text: string): React.ReactNode => {
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        const href = part.startsWith("http") ? part : `https://${part}`;
        return (
          <a
            key={index}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#2563eb", textDecoration: "underline" }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  /* downloadImage = async (url: string, fileName: string = "") => {
    if (this.isNotEmpty(url)) {
      if (this.isEmpty(fileName)) {
        const urlArr: Array<string> = url.split("/");
        fileName = urlArr[urlArr.length - 1];
        console.log(fileName);
      }
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }; */
})();

export default UtilityHelper;
